module.exports = __webpack_public_path__ + "img/Expo-Amy-Aromatherapy-in-Action.650ebd54.png";